export default {
  PaletteFooter: {
    backgroundColor: "white",
    height: "4vh",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    alignContent: "center",
    fontWeight: "bold",
    marginBottom: "1rem",
  },

  emoji: {
    fontSize: "1.5rem",
    margin: "0 1rem",
    marginBottom: "0.5rem",
  },
};
